import PropTypes from 'prop-types';
import * as React from 'react';
import { Spacings } from '@styles/index';
import { pluralize } from '@utils/textHelper';
import {
  UpcomingCourses,
  EnrolledCourses,
  CoursesInfo
} from './TopicCardElements';

const TopicGroupCardInfoText = ({
  topic,
  topologyCoursesCount,
  isSubscribed
}) => {
  const { upcomingCoursesCount, enrolledCoursesCount } = topic;
  let renderPrimaryCoursesCount = null;
  let renderSecondaryCoursesCount = '';
  const topologyCourses =
    topologyCoursesCount > 0 ? pluralize(topologyCoursesCount, 'course') : '';
  if (!isSubscribed) {
    if (upcomingCoursesCount > 0) {
      renderPrimaryCoursesCount = (
        <UpcomingCourses>{`${upcomingCoursesCount} upcoming`}</UpcomingCourses>
      );
      renderSecondaryCoursesCount = `${Spacings.SPACING_1SPACE}• `;
    }
    renderSecondaryCoursesCount += topologyCourses;
  } else {
    if (enrolledCoursesCount > 0) {
      renderPrimaryCoursesCount = (
        <EnrolledCourses>{`${enrolledCoursesCount} enrolled`}</EnrolledCourses>
      );
    } else if (topologyCoursesCount > 0) {
      renderPrimaryCoursesCount = topologyCourses;
    } else {
      renderPrimaryCoursesCount = 'Courses will be added soon';
    }
    if (upcomingCoursesCount > 0) {
      renderSecondaryCoursesCount = `${Spacings.SPACING_1SPACE}• ${upcomingCoursesCount} upcoming`;
    }
  }
  return (
    <CoursesInfo>
      {renderPrimaryCoursesCount}
      {renderSecondaryCoursesCount}
    </CoursesInfo>
  );
};

TopicGroupCardInfoText.propTypes = {
  topic: PropTypes.objectOf(PropTypes.any).isRequired,
  topologyCoursesCount: PropTypes.number.isRequired,
  isSubscribed: PropTypes.bool.isRequired
};

export default TopicGroupCardInfoText;
